/**
 * Lời gọi API danh sách shop dùng chung server + client (loader phân trang).
 * Tách khỏi server.ts (có React cache() + nhiều Service) để client bundle chỉ kéo ShopService.
 */
import { get } from "utils/lodash";
import ShopService from "services/shop";

/** Trang 1 của dải "Địa điểm khác" trang chủ (12 shop, điểm cao trước) */
export const HOME_SHOP_PAGE_SIZE = 12;
export const fetchHomeShops = async ({
  page = 1,
  limit = HOME_SHOP_PAGE_SIZE,
  category,
}: {
  page?: number;
  limit?: number;
  category?: string;
}) => {
  const res = await ShopService.find({
    page,
    limit,
    sort: "-rating",
    where: category ? { mainShopCategory: { equals: category } } : {},
  });
  return {
    data: (get(res, "data") || []) as any[],
    total: (get(res, "params.total") as number) || 0,
  };
};
